import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
const includes = ['Manual Maestro del Carpintero de Acero (desde cero)', 'Catálogo de los 10 Muebles Más Vendidos con planos', 'Guía de Costeo y Presupuesto Anti-Inflación', 'Master de Ventas en Marketplace y WhatsApp', 'Diseños en Melamina y Muebles Combinados', '3 Bonos Exclusivos de regalo', 'Bono Gym: Planos de Estructuras Metálicas para Gimnasios', 'Acceso inmediato en formato PDF — celular o PC'];
export function IncludesSection() {
  return <section className="py-20 px-4 bg-brand-light" data-id="element-210">
      <div className="max-w-4xl mx-auto" data-id="element-211">
        <h2 className="text-3xl md:text-4xl font-black text-center text-brand-dark mb-12" data-id="element-212">
          Todo lo que incluye tu Mega Pack:
        </h2>

        <div className="bg-white p-8 md:p-12 rounded-3xl shadow-xl mb-12" data-id="element-213">
          <ul className="space-y-6" data-id="element-214">
            {includes.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-215">
                <div className="bg-brand-green/10 p-1 rounded-full flex-shrink-0 mt-1" data-id="element-216">
                  <CheckIcon className="w-6 h-6 text-brand-green" strokeWidth={3} data-id="element-217" />
                </div>
                <span className="text-xl font-medium text-gray-800" data-id="element-218">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>

        <div className="max-w-xl mx-auto" data-id="element-219">
          <CTAButton text="→ QUIERO TODO ESTO AHORA" href="#compra" data-id="element-220" />
        </div>
      </div>
    </section>;
}